<template>
  <el-form @submit.native.prevent>
    <!-- 修改手机 -->
    <zt-dialog
      class="dialog-modify-phone"
      v-bind="$attrs"
      v-on="$listeners"
      @closed="onClosed"
      :append-to-body="true"
      :modal-append-to-body="false"
    >
      <p>修改新的手机号码</p>

      <el-form-item class="mt16" :error="phoneErr">
        <el-input placeholder="请输入新的手机号码" v-model.trim="telephone" />
      </el-form-item>

      <el-form-item class="mt16" :error="passwordErr">
        <el-input type="password" placeholder="请输入旧密码" v-model.trim="password" />
      </el-form-item>

      <el-form-item class="mt16" :error="imgErr">
        <div class="code-input">
          <el-input placeholder="请输入图形验证码" v-model="captcha_code" />
          <img class="code" :src="imgCode" @click="onRefreshImageCode" />
        </div>
      </el-form-item>

      <el-form-item class="mt16" :error="smsErr">
        <div class="code-input">
          <el-input placeholder="发送短信验证码" v-model="telephone_code" />
          <zt-button class="code" @click="onSendSms" :disabled="smsDisabled">{{ smsBtnText }}</zt-button>
        </div>
      </el-form-item>

      <zt-button type="primary" @click="onSubmit" @keyup.enter="onSubmit" native-type="submit">提交</zt-button>

      <p class="mt16">
        验证遇到问题
        <a href="#" class="link">请联系我们</a>
      </p>
    </zt-dialog>
  </el-form>
</template>

<script>
import ZtDialog from '@cps/ZtDialog';
import createUniqueString from '@/utils/createUniqueString';
import { captcha } from '@/api/login';
import { auth_sms_code } from '@/api/pidManage';
import { taoke_mytelephone_change } from '@/api/myCenter';
import { countdownSeconds } from '@/utils/timer';
import { sleep } from '@/utils/timer';

export default {
  components: {
    ZtDialog,
  },
  props: {
    submit: Function,
  },
  computed: {
    // 图形验证码url
    imgCode() {
      return captcha(this.captcha_r, this.captcha_t);
    },
  },
  data: () => ({
    telephone: '',
    password: '', // 旧密码
    captcha_t: Date.now(), // 图形验证码种子
    captcha_r: createUniqueString(), // 图形验证码随机key
    captcha_code: '', // 图形验证码
    telephone_code: '', // 短信验证码

    phoneErr: '',
    passwordErr: '',
    imgErr: '',
    smsErr: '',

    smsBtnText: '获取验证码',
    smsDisabled: false, // 按钮disabled状态
    smsCountdownTimer: null, // 倒计时定时器
  }),
  watch: {
    telephone_code(v) {
      if (!v) this.smsErr = '';
    },
    captcha_code(v) {
      if (!v) this.imgErr = '';
    },
  },
  methods: {
    // 刷新图形验证码
    onRefreshImageCode() {
      this.captcha_t = Date.now();
    },

    // 发送短信
    onSendSms() {
      let sendData = {
        telephone: this.telephone,
        captcha_r: this.captcha_r,
        captcha_code: this.captcha_code,
      };
      auth_sms_code(sendData, true).then(({ data }) => {
        let { error_code, error_message } = data;
        if (error_code == 6) {
          this.imgErr = error_message;
        } else if (error_code == 7) {
          this.smsErr = error_message;
        } else if (error_code != 0) {
          this.$message.error(error_message);
        } else {
          // 备份正确的图形验证码
          this.cbcaptcha_code = this.captcha_code;
          this.imgErr = '';
          // 倒计时60s
          clearInterval(this.smsCountdownTimer);
          this.smsCountdownTimer = countdownSeconds({
            current: (count) => {
              this.smsBtnText = count;
              this.smsDisabled = true;
            },
            lastone: () => {
              this.smsDisabled = false;
              this.smsBtnText = '获取验证码';
            },
            count: 60,
          });
        }

        if (error_code != 0) {
          // this.onRefreshImageCode()
        }
      });
    },

    // 提交 - 修改手机号码
    onSubmit() {
      if (this.captcha_code != this.cbcaptcha_code) {
        this.imgErr = '图形验证码错误';
        // this.onRefreshImageCode()
        return;
      }
      taoke_mytelephone_change({
        password: this.password,
        telephone: this.telephone,
        telephone_code: this.telephone_code,
      }).then(({ data }) => {
        var { error_code, error_message } = data;
        if (error_code == 0) {
          this.$emit('update:visible', false);
          this.$message({
            type: 'success',
            message: '修改手机号成功',
          });
          sleep(() => {
            this.$store.dispatch('LogOut').then(() => {
              this.$router.push({
                path: '/',
              });
            });
          }, 1000);
        } else if (error_code == 4) {
          this.passwordErr = error_message;
        } else {
          this.$message({
            type: 'error',
            message: error_message,
          });
        }
      });
    },

    // 关闭对话框
    onClosed() {
      this.captcha_code = '';
      this.telephone_code = '';
      this.onRefreshImageCode();
    },
  },
};
</script>

<style lang="scss" scoped>
.dialog-modify-phone /deep/ {
  .el-dialog__body {
    text-align: center;
  }
}

.el-form-item {
  margin: 0 auto 22px auto;
  width: 240px;
}

// 二维码输入框
.code-input {
  position: relative;
  line-height: 44px;

  .el-input /deep/ .el-input__inner {
    padding-right: 100px;
  }

  .code {
    position: absolute !important;
    right: 1px;
    top: 3px;
    height: 38px;
    width: 97px;
    background: #fff;
    border-left: 1px solid $theme-border3;
    cursor: pointer;
    display: block;
  }

  .el-button.code {
    padding: 0;
    color: $theme;
    border-radius: 0;
    border: none;
    border-left: 1px solid $theme-border3;
  }
}

.link {
  color: $theme;
}
</style>